import React, { useCallback, useEffect, useState } from 'react';
import Overlay from '@/components/atoms/overlay';
import SearchInput from '@/components/atoms/search-input';
import useMediaQuery from '@/hooks/useMediaQuery';
import { tablet } from '@/constants/screensizes';
import Typography from '@/components/atoms/typography';
import useScrollBlock from '@/hooks/useScrollBlock';
import useClassNames from './hooks/useClassNames';
import { SearchProps } from './types';

const Search = ({
  disabled,
  searchValue,
  suggestions,
  variant = 'sm',
  placeholder,
  onClick,
  handleOnChange,
  scrollControl,
  onSubmit,
  inputContinerClassName,
  noSearchButton = false,
  onKeyDown,
  searchButtonClassNames,
  noResultsMessage = '',
}: SearchProps) => {
  const [focused, setFocused] = useState(true);
  const onFocus = useCallback(() => setFocused(true), []);
  const onBlur = useCallback(() => {
    setTimeout(() => setFocused(false), 200);
  }, []);

  const { SearchWrapperClassNames, searchPanelClassNames } = useClassNames(variant, focused);

  const [isLargerThanTablet, width] = useMediaQuery(tablet);
  const showNoResultsMessage = !!noResultsMessage;

  const handleOnBackClick = () => {
    setFocused(false);
  };

  const { blockScroll } = useScrollBlock();
  useEffect(() => {
    scrollControl && blockScroll(focused);
  }, [blockScroll, focused, scrollControl]);

  return (
    <>
      {width >= tablet && focused && variant === 'lg' && <Overlay />}
      <div className={SearchWrapperClassNames}>
        <SearchInput
          containerClassName={inputContinerClassName}
          mobile={!isLargerThanTablet && focused}
          disabled={disabled}
          searchValue={searchValue}
          onFocus={onFocus}
          onBlur={onBlur}
          variant={variant}
          placeholder={placeholder}
          handleOnChange={handleOnChange}
          onBackClick={handleOnBackClick}
          onSubmit={onSubmit}
          noButton={noSearchButton}
          onKeyDown={onKeyDown}
          searchButtonClassName={searchButtonClassNames}
        />
        {noResultsMessage && (
          <div className="flex h-12 items-center hover:bg-neutral-200 px-3">
            <Typography fontSize={16} className="truncate text-gray-700">
              {noResultsMessage}
            </Typography>
          </div>
        )}

      </div>

    </>
  );
};
export default Search;
